import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../services/api';

export interface BacktestMetrics {
  annualReturn: number;
  sharpeRatio: number;
  maxDrawdown: number;
  winRate: number;
  calmarRatio: number;
  volatility: number;
  alpha: number;
  beta: number;
  informationRatio: number;
  sortinoRatio: number;
  treynorRatio: number;
  jensenAlpha: number;
  trackingError: number;
  var95: number;
  cvar95: number;
  skewness: number;
  kurtosis: number;
  lastUpdated: string;
}

interface MetricsState {
  data: BacktestMetrics | null;
  loading: boolean;
  error: string | null;
  lastUpdated: string | null;
}

const initialState: MetricsState = {
  data: null,
  loading: false,
  error: null,
  lastUpdated: null,
};

export const fetchMetrics = createAsyncThunk(
  'metrics/fetch',
  async (params: { strategy?: string; startDate?: string; endDate?: string } = {}) => {
    const response = await api.get('/metrics', { params });
    return response.data;
  }
);

export const fetchMetricsHistory = createAsyncThunk(
  'metrics/fetchHistory',
  async (params: { days?: number; strategy?: string } = {}) => {
    const response = await api.get('/metrics/history', { params });
    return response.data;
  }
);

const metricsSlice = createSlice({
  name: 'metrics',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    updateMetrics: (state, action) => {
      state.data = { ...state.data, ...action.payload };
      state.lastUpdated = new Date().toISOString();
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMetrics.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMetrics.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.lastUpdated = action.payload.timestamp || new Date().toISOString();
      })
      .addCase(fetchMetrics.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || '获取指标数据失败';
      })
      .addCase(fetchMetricsHistory.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMetricsHistory.fulfilled, (state, action) => {
        state.loading = false;
        // 处理历史数据
        state.data = action.payload.data;
      })
      .addCase(fetchMetricsHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || '获取历史指标数据失败';
      });
  },
});

export const { clearError, updateMetrics } = metricsSlice.actions;
export default metricsSlice.reducer;










